<template>
  <v-container>
    <v-form @submit.prevent="submit" ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-img
            class="my-2"
            src="@/assets/Bradbury_logo_2022.jpg"
            max-height="100"
            contain
            position="center"
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h7">PRE-AGREEMENT STATEMENT AND QUOTATION</span>
        </v-col>
        <v-col cols="6" class="text-center">
          <span class="text-caption"
            >These quotations are valid for 5 business days</span
          >
        </v-col>
      </v-row>
      <v-spacer class="pb-1"></v-spacer>
      <v-row>
        <v-col cols="12">
          <span class="text-h5">
            PART 1: THE CREDIT PROVIDER OFFERS THE FOLLOWING AVAILABLE LOANS:
          </span>
        </v-col>
      </v-row>
      <v-spacer class="pb-1"></v-spacer>
      <v-row>
        <v-col cols="12">
          <span class="text-caption">Maximum Repayment: ± 25% of Salary</span>
        </v-col>
      </v-row>
      <v-row v-if="loanTypes">
        <v-col cols="12">
          <ApplicationTable
            v-model="loanApplication.loanType"
            :loanTypes="loanTypes"
          />
        </v-col>
      </v-row>
      <v-row class="pb-2" justify="center">
        <span class="text-h6">
          Repayment date: (Default:
          {{ defaultRepaymentDate }})</span
        >
      </v-row>
      <v-row class="pb-5" justify="center">
        <v-date-picker
          v-model="loanApplication.repaymentDate"
          year-icon="mdi-calendar-blank"
          color="primary"
          :min="earliestRepaymentDate"
          :show-current="true"
          elevation="10"
        >
        </v-date-picker>
      </v-row>
      <v-row class="pb-5">
        <v-col cols="12">
          <span class="text-p">
            The Company agrees: To deduct the number of repayments from the
            Applicant's salary monthly & pay same over to the Credit Provider or
            its nominee. In the event of the employee leaving the Company, the
            outstanding loan balance becomes immediately due.
            <br />The Employee hereby authorises the Company to deduct the
            agreed monthly instalment from their salary each month until the
            full loan amount, including any applicable fees and interest, has
            been repaid. The Employee hereby authorises the Employer to deduct
            from any remuneration due to them, including but not limited to
            bonuses, overtime, leave pay, and/or any other accrued benefits, any
            amounts owing under this loan agreement until the debt is fully
            settled. If, further to this, there is still an outstanding balance,
            we hereby acknowledge Bradbury Finance will process the deduction
            via debit order on my bank account nominated.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h5">PART 2: EMPLOYER / COMPANY:</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="modelCompany.name"
                label="Company:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="companyMetaData.region"
                label="Region:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="companyMetaData.branch"
                label="Branch:"
                type="string"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h7">MONTHLY SHORT TERM CREDIT TRANSACTION</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5"
            >PART 3: The Applicant / Consumer / Employee</span
          >
        </v-col>
        <v-col cols="6">
          <span class="text-caption">
            The Applicant / Consumer / Employee hereafter referred to as the
            Applicant
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <span class="text-p">The Applicant:</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.name"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>FIRST NAMES:
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.surname"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>SURNAME:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.title"
                label="TITLE:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="employee.idNumber" :rules="requiredRule">
                <template #label>
                  <span class="red--text font-weight-bold">* </span>ID/Passport
                  Number:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.cell"
                type="number"
                :rules="cellRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>CONTACT TELL
                  No.:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.address"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>ADDRESS:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="employee.email"
                type="string"
                label="EMAIL:"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employeeClockNumber"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>PERSONNEL /
                  CLOCK NUMBER:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-file-input
                prepend-icon="mdi-file-document"
                v-model="loanApplication.uploadPayslip"
                multiple
                placeholder="Select all at once"
                chips
                name="payslip_upload"
                accept="image/*, .pdf"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>Latest
                  Payslip:
                </template></v-file-input
              >
            </v-col>
            <v-col cols="12">
              <v-file-input
                prepend-icon="mdi-card-account-details"
                v-model="loanApplication.uploadId"
                chips
                name="id_upload"
                accept="image/*, .pdf"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span
                  >Identification/Passport:
                </template></v-file-input
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <span class="text-p">The Applicant's Spouse:</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseName"
                label="FIRST NAMES:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseSurname"
                label="SURNAME:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseTitle"
                label="TITLE:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseIdNumber"
                label="ID/Passport Number:"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseCell"
                label="CONTACT TELL No.:"
                type="number"
                :rules="spouseCellRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseAddress"
                label="ADDRESS:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseEmail"
                label="EMAIL:"
                type="string"
                :rules="spouseEmailRule"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row no-gutters>
            <span class="text-h6">Signature:</span>
          </v-row>
          <v-row no-gutters>
            <v-card outlined color="green">
              <v-card-title class="pa-2">Example:</v-card-title>
              <v-img
                src="@/assets/exampleSignatureImg.png"
                :width="signatureImgSize"
                contain
                eager
                position="left"
              ></v-img
            ></v-card>
          </v-row>
          <div :style="signatureInputStyle">
            <v-file-input
              prepend-icon="mdi-image-plus"
              v-model="loanApplication.signatureImage"
              placeholder="Select image"
              name="signature_upload"
              accept="image/*, .pdf"
              :rules="requiredRule"
            >
              <template #label>
                <span class="red--text font-weight-bold">* </span>Upload
                signature:
              </template></v-file-input
            >
          </div>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <span class="text-h6">Proof of Banking Account:</span>
          </v-row>
          <v-row no-gutters>
            <v-card outlined color="green">
              <v-card-title class="pa-2">Examples:</v-card-title>
              <v-row class="pa-0 ma-0" justify="center">
                <v-img
                  src="@/assets/exampleProofOfBankImg_1.png"
                  :width="proofOfBankImgSize"
                  aspect-ratio="1.5775"
                  contain
                  eager
                  position="center"
                >
                </v-img>
                <v-img
                  src="@/assets/exampleProofOfBankImg_2.png"
                  :width="proofOfBankImgSize"
                  aspect-ratio="1.5775"
                  contain
                  eager
                  position="center"
                >
                </v-img>
              </v-row>
            </v-card>
          </v-row>
          <div :style="proofOfBankInputStyle">
            <v-file-input
              prepend-icon="mdi-image-plus"
              v-model="loanApplication.proofOfBank"
              placeholder="Select image"
              name="proofOfBank_upload"
              accept="image/*, .pdf"
              :rules="requiredRule"
            >
              <template #label>
                <span class="red--text font-weight-bold">* </span>Upload Proof
                of banking:
              </template></v-file-input
            >
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            v-model="loanApplication.consent"
            label="I hereby give consent that, at my request, Bradbury Finance Pty Ltd may
        forward my necessary details to another service provider in the event
        they cannot assist me."
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5">PART 4: BANK DETAILS OF APPLICANT</span>
        </v-col>
        <v-col cols="6">
          <span class="red--text text-caption">
            (This information is very important for payment into Applicant's
            account)
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex flex-column">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.bankName"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>NAME OF
                  BANK:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.branchName"
                label="BRANCH NAME:"
                type="string"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.branchNumber"
                label="BRANCH No.:"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.accountNumber"
                type="number"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>ACCOUNT No.:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.accountName"
                type="string"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>ACCOUNT
                  NAME:
                </template></v-text-field
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h7"
            >PLEASE COMPLETE THE FOLLOWING INFORMATION:</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.grossSalary"
                type="number"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>GROSS
                  SALARY:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.nettSalary"
                type="number"
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>NETT SALARY:
                </template></v-text-field
              >
            </v-col>
            <v-col cols="12"
              ><v-row
                ><v-col cols="5">
                  <v-select
                    v-model="expenseType"
                    :items="Object.keys(expenses)"
                    return-object
                    :rules="requiredRule"
                  >
                    <template #label>
                      <span class="red--text font-weight-bold">* </span>SELECT
                      AN EXPENSE
                    </template></v-select
                  ></v-col
                >
                <v-col cols="5">
                  <v-text-field
                    v-model="expenseAmount"
                    type="number"
                    :rules="requiredRule"
                    @keyup.enter="addExpense()"
                  >
                    <template #label>
                      <span class="red--text font-weight-bold">* </span>EXPENSE
                      AMOUNT:
                    </template></v-text-field
                  >
                </v-col>
                <v-col cols="2">
                  <v-btn class="mx-2" fab dark small @click="addExpense()">
                    <v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-data-table
                  :items="loanApplication.expenses"
                  :headers="expenseHeaders"
                  hide-default-footer
                  :items-per-page="20"
                  no-data-text="No expenses added yet"
                  class="grey lighten-4"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small @click="deleteItem(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="totalLeft"
                type="number"
                :rules="requiredRule"
                readonly
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>TOTAL LEFT:
                </template></v-text-field
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.underAdministration"
                :label="
                  yesNo(
                    'ARE YOU UNDER ADMINISTRATION ?',
                    loanApplication.underAdministration
                  )
                "
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.isThisEmergencyLoan"
                :label="
                  yesNo(
                    'IS THIS AN EMERGENCY LOAN ?',
                    loanApplication.isThisEmergencyLoan
                  )
                "
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.underDeptReview"
                :label="
                  yesNo(
                    'ARE YOU UNDER DEBT REVIEW ?',
                    loanApplication.underDeptReview
                  )
                "
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="acceptAll"
                @click="acceptAllClick()"
                :label="`ACCEPT ALL OF THE ABOVE`"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="loanApplication.loanPurpose"
                :items="Object.keys(loanPurposes)"
                return-object
                :rules="requiredRule"
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>WHAT IS THE
                  PURPOSE OF THE LOAN ?
                </template></v-select
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.loanPurposeOther"
                type="string"
                :disabled="loanApplication.loanPurpose !== loanPurposes.OTHER"
                :rules="
                  loanApplication.loanPurpose == loanPurposes.OTHER
                    ? requiredRule
                    : []
                "
              >
                <template #label>
                  <span class="red--text font-weight-bold">* </span>OTHER LOAN
                  PURPOSE:
                </template></v-text-field
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pb-5">
        <v-col cols="12">
          <span class="text-p">
            I agree that the Credit Provider may request and obtain any
            financial information about me on record from the National Credit
            Register and Credit Bureau.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5">PART 5: AGREEMENT</span>
        </v-col>
        <v-col cols="6">
          <span class="text-caption"
            >which includes Debit order authorization DEBICHECK</span
          >
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-2">
        <v-card color="primary" max-width="95%">
          <v-row no-gutters>
            <v-select
              v-model="currentAudioFileName"
              :items="audioFileNames"
              @change="whatAudioFile(currentAudioFileName)"
              :label="currentAudioFileName"
              solo
              dense
              dark
              flat
              color="white"
              background-color="green darken-1"
              style="
                margin-bottom: -20px;
                margin-top: 4px;
                margin-left: 4px;
                margin-right: 4px;
              "
            ></v-select>
          </v-row>
          <v-row
            v-if="currentAudioFile && audioLoaded"
            no-gutters
            class="pb-1 px-1 justify-center"
          >
            <audio controls style="height: 35px">
              <source :src="currentAudioFile" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </v-row>
          <v-row v-else no-gutters class="pb-1 px-1 justify-center">
            <span class="white--text">No audio file found.</span>
          </v-row>
        </v-card>
      </v-row>
      <v-row class="pb-5 mt-0">
        <v-col cols="12" style="text-align: justify">
          <span class="text-p">
            The Borrower herewith applies in the language of his / her choice.
            The Borrower herewith applies for the above selected loan and
            authorizes herewith irrevocably the Employer to deduct the amount
            and number of monthly repayments from his /her salary until the loan
            has been settled. The Borrower accepts that the Credit Provider may
            request & obtain any financial information about the Borrower on
            record from the National Credit Register & Credit Bureau & accepts
            that this loan will be listed on Credit Bureau. The Borrower hereby
            agrees that in the event of him/her leaving and there is an
            outstanding amount due on the loan, Bradbury Finance has the
            Borrower’s authorization to debit the Borrower’s bank account with
            the outstanding due. The Credit Provider shall consider the
            application and if approved, pay the amount of the loan directly
            into the Borrower’s designated bank account. The Employer of the
            Borrower undertakes to deduct the monthly repayment from the
            Borrower’s salary & pay same over to the Credit Provider's nominated
            account at the end of every month. In the event of the Borrower’s
            employment being terminated, for whatever reason, the Borrower
            hereby authorizes Credit Provider to issue and deliver debit order
            payment instructions to the Borrower’s banker for collection against
            my above-mentioned account and Bank indicated above on condition
            that the sum of each payment instruction and frequency of payment
            requests will never exceed the obligations as agreed and defined in
            the Agreement specified. The Borrower can only service the
            obligations defined in here if the payment instructions are executed
            as close as possible to when I receive my salary or wages which
            dates vary from month to month, especially during December of each
            year. To curb against (1) unpaid bank charges (2) losing the
            benefits described in the agreement quoted (3) incurring penalties
            due to non-payment; the Borrower explicitly authorize Credit
            Provider to utilize the functionality of Tracing supported on the
            DEBICHECK Payment Stream. Tracking supported on the DEBICHECK
            Payment Stream has been explained to me and I acknowledge that my
            above-mentioned account will be interrogated for a defined period
            until this period has lapsed or until payment was received. The
            Borrower hereby agree that in instances of an unpaid item, Credit
            Provider may submit the arrear payment together with a further due
            payment in any payment cycle or frequency as indicated above. The
            Borrower hereby agrees that subsequent payment instructions will
            continue to be delivered in terms of this authority until all
            obligations have been paid. This authorization will remain in force
            until cancelled by me in writing. The Borrower hereby acknowledges
            that my bank will charge fees to my account as agreed with them once
            they process this instruction. In terms of section 40(1) of the
            National Credit Act 34 of 2005 read with the threshold prescribed in
            terms of section 42(1) of the Act, registration as a credit provider
            is required if the total principal debt owed to the credit provider
            (or any associated person) in terms of all current credit agreements
            (other than incidental credit agreements) exceeds R500 000. The
            Borrower must pay interest at the rate declared on the first page of
            this contract. The interest must be paid together with the repayment
            of the capital sum of the loan at the conclusion of the loan period.
            The Borrower expressly renounces the benefits of the exceptio non
            numeratae pecuniae (the defence that the money has not been paid)
            and confirms that he/she understands the meaning of this exception
            and the effect of its renunciation. If repayment is made by way of
            monthly instalments, all payments must be made by the Borrower on or
            before the third business day of every month at (address at which
            payment must be made) or such other address as the lender may at a
            later stage advise in writing. If the Borrower fails to pay any
            instalment on the due date, the Credit Provider can immediately
            claim the full balance of the loan together with interest up to the
            date of payment. No relaxation by the lender in enforcing the
            acceleration clause at any stage will amount to a waiver of the
            lender's rights in terms of that clause. The Borrower can pay larger
            instalments than prescribed, or can pay the full balance of capital
            and interest at any time prior before the prescribed dates for
            payment. In that event, interest will be calculated only up to the
            date of payment. The Borrower may settle this agreement at any time
            in terms of section 125 of the National Credit Act 34 of 2005 by
            paying the unpaid balance of the loan amount, unpaid interest
            charges and all other fees and charges up to the date of settlement.
            If the Borrower does not make payment of any instalment on the due
            date for the payment of that instalment and the Credit Provider
            decides to enforce the acceleration clause, the lender must first
            give written notice to the borrower calling upon him or her to make
            payment within (insert number) days, failing which the lender will
            immediately thereafter be entitled to claim payment of whatever is
            due in terms of this agreement. In terms of Section 123 of the
            National Credit Act 34 of 2005, the lender reserves the right to
            terminate (cancel) this loan agreement with the Borrower if the
            Borrower defaults in making payment of any of the agreed repayments
            due in terms of this agreement, and the lender may thereafter
            proceed in terms of Section 129(1)(b) and Section 130 of the
            National Credit Act, which may result in a court of law enforcing
            the repayment of the borrower's outstanding obligations in terms of
            this agreement and in the judgment of the court being recorded by
            credit bureau. In the event of a breach by the Borrower of this
            agreement, the Borrower consents to the grant by a court of
            competent jurisdiction of an emoluments attachment order in respect
            of the amount of the judgment debt pursuant to the provisions of the
            Magistrates' Courts Act 32 of 1944 governing such orders. 22. The
            full balance of the capital and interest shall become payable
            immediately upon sequestration of the Borrower's estate. The parties
            confirm that this contract contains the full terms of their
            agreement and that no addition to or variation of this contract will
            be of any force or effect unless reduced to writing and signed by
            both parties. The parties choose as their respective domicilia
            citandi et executandi. I hereby authorise Bradbury Finance Pty Ltd
            to issue and deliver debit order payment instructions to your banker
            for collection against my Account and Bank used by my employer to
            deposit my salaries/wages, which account may differ from the account
            specified above on condition that the sum of each payment
            instruction and frequency of payment requests will never exceed the
            obligations as agreed and defined in the Agreement specified. My
            bank’s participation in the relevant payment stream, the
            authentication mechanism used by me, and the relevant rules
            applicable to the payment streams will determine per repayment cycle
            the most suitable payment stream in order to fulfil the obligations
            as defined in the agreement. My authorisation is subject thereto
            that the same payment instruction may never be presented
            simultaneously in more than one payment stream during the same
            repayment cycle or, if unpaid in a payment stream selected to be
            represented in the same cycle in another payment stream. I can only
            service the obligations defined in here if the payment instructions
            are executed as close as possible to when I receive my salary or
            wages which dates vary from month to month, especially during
            December of each year. To curb against (1) unpaid bank charges (2)
            losing the benefits described in the agreement quoted (3) incurring
            penalties due to non-payment; I explicitly authorise Bradbury
            Finance Pty Ltd to utilise the functionality of Tracking supported
            on the Authenticated and EDO Payment Streams especially after
            unsuccessful attempts on the EFT Payment Stream. Tracking supported
            on the Authenticated and EDO Payment Streams has been explained to
            me and I acknowledge that my above-mentioned account will be
            interrogated for a defined period until this period has lapsed or
            until payment has been received. I hereby agree that subsequent
            payment instructions will continue to be delivered in terms of the
            authority until all obligations have been paid. This authorisation
            will remain in force until cancelled by me in writing. I hereby
            acknowledge that my bank will charge fees to my account as agreed
            with them once they process this instruction. I foresee that I may
            change my bank and bank account particulars reflected in here, in
            which instance I will notify the beneficiaries specified, or any new
            beneficiary, should the agreement be ceded or assigned to any third
            party. Should I however forget to notify the beneficiary or the
            assigned third party and if the beneficiary or the assigned third
            party obtain my new bank particulars, on my account, this mandate
            will not lapse. This issued mandate will cover the obtained bank
            information and the beneficiary and the assigned third party may
            attach such new information, to this signed document as annexure,
            and the attached annexure must be read together with this mandate,
            by my new bank.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-center text-h5">SCHEDULE</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="red--text text-h7">STANDARD TERMS AND CONDITIONS</span>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col style="text-align: justify">
          <span class="text-p">
            1. The Consumer / Applicant declares that by making the monthly
            repayment of this agreement, he/ she will still be able to satisfy
            in a timely manner all his /her other obligations under other credit
            agreements. 2. The above listed addresses of the Consumer /
            Applicant and Credit Provider will prevail where documents and legal
            process will be accepted. A change of address will be notified in
            writing to the other party by delivering same by fax, email,
            registered mail or by hand. 3. The Consumer / Applicant will recieve
            monthly statements of account at the address of his / her Employer.
            4. The Applicant may terminate this agreement at any time by paying
            the settlement amount comprising of the balance of the amount of the
            loan and the outstanding amount of interest and administration fee
            as at the date of settlement. 5. The Credit Provider may terminate
            the agreement if the Consumer / Applicant is in default. 6. Any
            amount in arrears due to the default of the Consumer / Applicant
            will attract interest at the same rate as the loan said above. 7.
            Any extension of time or indulgences granted by the Credit provider,
            shall not constitute a waiver of its rights under this agreement. 8.
            Every term in this agreement is divisible from the other. Should any
            term be unenforceable, void or voidable, the validity of the rest of
            the agreement shall not be affected. 9. The above comprises the
            entire agreement between the parties and any change thereof in
            whatsoever manner shall be in writing and signed by the concerned
            parties. 10. Should the Applicant default on any payment, Bradbury
            Finance (Pty) Ltd, shall have the right without prejudice to any of
            its other rights to give the Applicant notice to rectify such
            breach; act of insolvency, etc. within twenty (20) working days ,
            and if not so rectified within such notice period elect to: • Treat
            as immediately due and payable all outstanding amounts currently due
            and payable; • Cancel the agreement and apply for an order at the
            appropriate court claiming all outstanding amounts as well as all
            legal fees on an Attorney Client Basis;” 11. The Applicant shall be
            liable for all costs by Bradbury Finance (Pty) Ltd in recovery of
            any amounts or the enforcement of any rights which it has hereunder,
            including collection charges and costs on an attorney and client
            scale and costs of counsel as on brief incurred during the
            institution of legal proceedings if judgement has been granted, in
            connection with the satisfaction or enforcement of such judgement by
            an appropriate court. This is subject to the jurisdiction of the
            relevant court or tribunal where the case will be adjudicated whom
            in their final discretion will determine the amount of costs for
            which the Applicant will be held liable. 12. The Applicant hereby
            consents to the Jurisdiction of the Magistrate’s Court having
            jurisdiction over its person in respect of proceedings arising from
            this agreement, even if e amount in issue would otherwise exceed the
            Jurisdiction of this court. 13. The Applicant acknowledges the risk
            involved in borrowing money from Bradbury Finance (Pty) Ltd and
            hereby indemnifies Bradbury Finance (Pty) Ltd against losses the
            Applicant might sustain with regards to the granting by Bradbury
            Finance (Pty) Ltd, due to reasons beyond the control of the credit
            provider. This will include any of the loan economical lost
            pertaining to the harm/losses caused. Compulsory Disclosures and
            Permitted Exclusions WHAT IS COVERED? - Death / permanent disability
            - outstanding balance of your loan - Temporary disability - your
            obligations that become due and payable until the end of the term of
            your loan, or until you are no longer disabled , whichever is
            shorter - Permanent Disability - your obligations become due and
            payable until the end of the term of your loan. The benefit will
            only be payable after six months of continues dyability, according
            to the insurers disability definition. - Unemployment / loss of
            income - your obligations that become due and payable until the end
            of the term of your loan, or until you find employment, or earn an
            income. Maximum 12 months. All benefits ceases on the last day of
            the month in which you reach the age of 65 years. WHAT IS EXCLUDED?
            DEATH AND DISABILITY Abuse of alcohol or narcotics; Suicide or
            self-inflicted injuries; Active participation in war or riots; Use
            of nuclear, chemical weapons or any radioactive contaminations;
            Participation in criminal activities; Participation in hazardous
            activities i.e. mountain climbing / bungee jumping / speed racing;
            Any pre-exisiting conditions that you were aware of that affected
            you in the 12 months preceding the commencement of this cover. The
            disability benefits will not apply to Insured lives, should the date
            of commencement of disability occur within twelve months of the
            entry date and the disability directly or indirectly arises from, or
            is traceable to (a) A bodily injury which occurred, or (b) Diseased
            condition of which the member was aware or experienced symptoms or
            for which the member received medical treatment, during the six
            months immediately prior to entry date. UNEMPLOYMENT OR INABILITY TO
            EARN AN INCOME A waiting period of 3 months will apply during which
            there is no cover or benefit. Retrenchment or termination within the
            first 3 months of commencement of the credit life insurance; Lawful
            dismissal; Voluntary forfeiture of salary; Voluntary retrenchment;
            Resignation; Retirement; Participating in an unprotected strike; or
            Retrenchment of which you were aware of or received notice of during
            the three months preceding date of credit life insurance, are all
            excluded. YOUR RIGHT TO CHOOSE The National Credit Act requires that
            Credit Life Insurance being offered to you as part of the loan
            offer. You may select to not take the credit life insurance, in
            which case you must do so in writing to your Employer and / or
            Union. In this event your Employer and / or Union may insist that
            you provide satisfactory proof of other cover for your obligations
            in terms of the loan that you are applying for. TERMS AND CONDITIONS
            APPLY WHICH CAN BE OBTAINED FROM BRADBURY FINANCE PTY LTD
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-center text-h5">
            COMPULSORY DISCLOSURES AND PERMITTED EXCLUSIONS
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-h6">WHAT IS COVERED?</span>
        </v-col>
      </v-row>
      <v-col class="mb-3">
        <ul>
          <li>
            Death / permanent disability - outstanding balance of your loan.
          </li>
          <li>
            Temporary disability - your obligations that become due and payable
            until the end of the term of your loan, or until you are no longer
            disabled , whichever is shorter.
          </li>
          <li>
            Permanent Disability - your obligations become due and payable until
            the end of the term of your loan. The benefit will only be payable
            after six months of continues dyability, according to the insurers
            disability definition.
          </li>
          <li>
            Unemployment / loss of income - your obligations that become due and
            payable until the end of the term of your loan, or until you find
            employment, or earn an income.
          </li>
          <li>Maximum 12 months.</li>
        </ul>
      </v-col>
      <v-row>
        <v-col>
          <span class="text-h7 font-weight-bold"
            >All benefits ceases on the last day of the month in which you reach
            the age of 65 years.</span
          >
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col>
          <span class="text-h6">WHAT IS EXCLUDED?</span>
        </v-col>
      </v-row>
      <v-col>
        <v-row>
          <span class="text-p">DEATH AND DISABILITY</span>
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >Abuse of alcohol or narcotics; Suicide or self-inflicted injuries;
            Active participation in war or riots; Use of nuclear, chemical
            weapons or any radioactive contaminations; Participation in criminal
            activities; Participation in hazardous activities i.e. mountain
            climbing / bungee jumping / speed racing; Any pre-exisiting
            conditions that you were aware of that affected you in the 12 months
            preceding the commencement of this cover The disability benefits
            will not apply to Insured lives, should the date of commencement of
            disability occur within twelve months of the entry date and the
            disability directly or indirectly arises from, or is traceable to
            (a) A bodily injury which occurred, or (b) Diseased condition of
            which the member was aware or experienced symptoms or for which the
            member received medical treatment, during the six months immediately
            prior to entry date.</span
          >
        </v-row>
        <v-row>
          <span class="text-p"
            >UNEMPLOYMENT OR INABILITY TO EARN AN INCOME</span
          >
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >A waiting period of 3 months will apply during which there is no
            cover or benefit. Retrenchment or termination within the first 3
            months of commencement of the credit life insurance; Lawful
            dismissal; Voluntary forfeiture of salary; Voluntary retrenchment;
            Resignation; Retirement; Participating in an unprotected strike; or
            Retrenchment of which you were aware of or received notice of during
            the three months preceding date of credit life insurance, are all
            excluded.</span
          >
        </v-row>
        <v-row>
          <span class="text-p">YOUR RIGHT TO CHOOSE</span>
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >The National Credit Act requires that Credit Life Insurance being
            offered to you as part of the loan offer. You may select to not take
            the credit life insurance, in which case you must do so in writing
            to your Employer and / or Union. In this event your Employer and /
            or Union may insist that you provide satisfactory proof of other
            cover for your obligations in terms of the loan that you are
            applying for.</span
          >
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >TERMS AND CONDITIONS APPLY WHICH CAN BE OBTAINED FROM BRADBURY
            FINANCE PTY LTD</span
          >
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <span class="red--text font-weight-bold">*</span>
          <span class="text-h6 ml-1">Full Name:</span>
        </v-row>
        <v-row>
          <v-text-field
            id="FullNameTextField"
            v-model="loanApplication.fullName"
            type="string"
            :rules="requiredRule"
          ></v-text-field>
        </v-row>
      </v-col>
      <v-row>
        <v-col class="text-center">
          <v-alert type="warning" v-if="!isValid" icon="mdi-alert-outline">
            To complete the application, please complete all the mandatory
            fields.
          </v-alert>
          <v-btn
            :dark="!loading"
            color="green"
            v-else-if="isValid"
            :loading="loading"
            :disabled="loading"
            center
            @click="submit"
            >Apply</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
    <div class="text-center">
      <v-dialog
        v-model="submitted"
        :width="submittedDialogSize"
        persistent
        overlay-opacity="0.7"
      >
        <v-card color="primary">
          <v-card-text
            class="pa-3 text-center text-body-1"
            style="color: white"
          >
            Thank you for submitting your application. We will contact you
            shortly.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              dark
              color="green darken-1"
              @click="completeSubmit"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="submitError"
        :width="submittedDialogSize"
        persistent
        overlay-opacity="0.7"
      >
        <v-card color="#fb8c00">
          <v-card-text
            class="pa-3 text-center text-body-1"
            style="color: white"
          >
            Unable to complete the action. Please ensure you have a stable
            internet connection and try again. If the problem persists, kindly
            reach out to Bradbury Finance for assistance.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              :dark="!loading"
              :loading="loading"
              :disabled="loading"
              @click="submit"
              class="mr-2"
            >
              Retry
            </v-btn>
            <v-btn depressed @click="completeSubmit"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import ApplicationTable from "./ApplicationTable";
import { Storage } from "@aws-amplify/storage";
import router from "@/router";
import { DataStore, syncExpression, API } from "aws-amplify";
import _ from "lodash";
import {
  LoanApplication,
  Employee,
  Status,
  CompanyLoanType,
  LoanPurposes,
  LoanStatus,
  Expenses,
  // LoanType,
  Company,
  LoanType,
} from "@/models";

export default {
  name: "ApplicationForm",

  data: () => ({
    audioLoaded: false,
    currentAudioFile: null,
    currentAudioFileName: "English",
    audioFileNames: ["English", "Afrikaans", "IsiZulu"],

    submitted: false,
    submitError: false,

    loading: false,
    earliestRepaymentDate: null,
    defaultRepaymentDate: null,
    acceptAll: null,
    valid: false,
    loanPurposes: LoanPurposes,
    expenses: Expenses,
    expenseType: null,
    expenseAmount: null,
    modelEmployee: {},
    modelCompany: {},
    companyMetaData: {
      region: null,
      branch: null,
    },
    loanTypes: null,
    expenseHeaders: [
      { text: "Expense", value: "type", class: "grey lighten-2" },
      { text: "Amount", value: "amount" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "grey lighten-2",
      },
    ],

    requiredRule: [(v) => !!v || "Required"],
    idRule: [
      (v) => !!v || "Required",
      (v) => (v && v.length === 13) || "Please provide a valid ID No.",
    ],
    cellRule: [
      (v) => !!v || "Required",
      (v) =>
        /^(\+)?(0|27)([5-9])([0-9])( )?([0-9]{3})( )?([0-9]{4})$/.test(v) ||
        "Please provide a valid Cellphone No.",
    ],
    emailRule: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    spouseIdRule: [
      (v) =>
        /^$/.test(v) ||
        (v && v.length === 13) ||
        "Please provide a valid ID No.",
    ],
    spouseEmailRule: [
      (v) => /^$|^.+@.+\..+$/.test(v) || "E-mail must be valid",
    ],
    spouseCellRule: [
      (v) =>
        /^$/.test(v) ||
        /^(\+)?(0|27)([5-9])([0-9])( )?([0-9]{3})( )?([0-9]{4})$/.test(v) ||
        "Please provide a valid Cellphone No.",
    ],

    employee: {
      title: null,
      name: null,
      surname: null,
      idNumber: null,
      email: null,
      address: null,
      cell: null,
      status: Status.ACTIVE,
      companyID: null,
    },
    loanApplication: {
      employeeID: null,
      spouseTitle: null,
      spouseName: null,
      spouseSurname: null,
      spouseIdNumber: "",
      spouseEmail: "",
      spouseAddress: null,
      spouseCell: "",
      bankName: null,
      branchName: null,
      branchNumber: null,
      accountName: null,
      accountNumber: null,
      grossSalary: null,
      nettSalary: null,
      expenses: [],
      totalLeft: null,
      underAdministration: null,
      underDeptReview: null,
      isThisEmergencyLoan: null,
      loanPurpose: null,
      loanPurposeOther: null,
      consent: null,
      status: LoanStatus.NEW,
      loanType: null,
      uploadPayslip: null,
      uploadId: null,
      employeeClockNumber: null,
      signatureImage: null,
      fullName: "",
      proofOfBank: null,
      repaymentDate: null,
    },
  }),
  async mounted() {
    try {
      await DataStore.stop();
      DataStore.configure({
        syncExpressions: [
          syncExpression(Company, () => {
            return (c) => c.id("eq", null);
          }),
          syncExpression(Employee, () => {
            return (c) => c.id("eq", null);
          }),
          syncExpression(CompanyLoanType, () => {
            return (c) => c.id("eq", null);
          }),
          syncExpression(LoanApplication, () => {
            return (c) => c.id("eq", null);
          }),
          syncExpression(LoanType, () => {
            return (c) => c.id("eq", null);
          }),
        ],
      });
      await DataStore.start();
      this.calendarCalc();
      this.queryLoanTypes();
      this.$refs.form.validate();
    } catch (error) {
      console.log(error);
    }

    this.employee.companyID = this.$route.params.companyId;
  },
  components: {
    ApplicationTable,
  },
  methods: {
    completeSubmit() {
      this.submitted = false;
      this.submitError = false;
      router.push({
        name: "Landing",
      });
    },
    deleteItem(item) {
      let expenseIndex = this.loanApplication.expenses.indexOf(item);
      if (expenseIndex !== -1) {
        this.loanApplication.expenses.splice(expenseIndex, 1);
      }
    },

    addExpense() {
      this.loanApplication.expenses.push({
        type: this.expenseType,
        amount: parseInt(this.expenseAmount),
      });

      let totalExpenseAmount = _.sumBy(this.loanApplication.expenses, "amount");

      this.loanApplication.totalLeft =
        this.loanApplication.nettSalary - totalExpenseAmount;
    },

    async queryLoanTypes() {
      try {
        let companyId = this.$route.params.companyId;
        let salaryFrequency = [];

        if (this.$route.params.salaryFrequency === "Monthly") {
          salaryFrequency = ["Months"];
        } else if (this.$route.params.salaryFrequency === "Weekly") {
          salaryFrequency = ["Wks/Mths", "Weeks"];
        } else if (this.$route.params.salaryFrequency === "Fortnightly") {
          salaryFrequency = ["Fortnights"];
        }

        // Query company details
        const companyQuery = `
          query ListCompanies($filter: ModelCompanyFilterInput) {
            listCompanies(filter: $filter) {
              items {
                id
                name
                companyEmail
                loanApplicationEmails
                pastelCode
                LoanTypes {
                  items {
                    loanType {
                      id
                      code
                      randValue
                      periodNumber
                      period
                      payment
                      interest
                      totalPayment
                      totalInterest
                      adminFee
                      serviceCharge
                      creditLifeFee
                      debitOrder
                      creditType
                    }
                  }
                }
              }
            }
          }
        `;

        const companyResponse = await API.graphql({
          query: companyQuery,
          variables: {
            filter: { id: { eq: companyId } },
          },
        });

        console.log("Company Query Response:", companyResponse);

        const companies = companyResponse.data.listCompanies?.items || [];
        if (companies.length === 0) {
          throw new Error("Company not found");
        }

        this.modelCompany = companies[0];
        this.modelCompany.loanApplicationEmails = JSON.parse(
          this.modelCompany.loanApplicationEmails
        );
        console.log("Model Company:", this.modelCompany);
        const modelLoanTypes =
          this.modelCompany.LoanTypes?.items?.map((ltc) => ltc.loanType) || [];

        this.loanTypes = modelLoanTypes.filter((lt) =>
          salaryFrequency.includes(lt.period)
        );

        // const modelLoanTypes = (await DataStore.query(CompanyLoanType))
        //   .filter((ltc) => ltc.company.id === companyId)
        //   .map((ltc) => ltc.loanType);
        // const queriedCompany = await DataStore.query(Company, (c) =>
        //   c.id('eq', this.$route.params.companyId)
        // );
        // this.modelCompany = queriedCompany[0];
        // this.loanTypes = modelLoanTypes.filter((lt) =>
        //   salaryFrequency.includes(lt.period)
        // );
        this.whatAudioFile("English");
      } catch (err) {
        console.log(err);
      }
    },
    calendarCalc() {
      try {
        let earliestDate = new Date();
        this.earliestRepaymentDate =
          earliestDate.getFullYear() +
          "-" +
          ("0" + (earliestDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + (earliestDate.getDate() + 1)).slice(-2);

        if (this.$route.params.salaryFrequency === "Monthly") {
          let currentDate = new Date();

          if (currentDate.getDate() < 8) {
            let lastDayOfMonth = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() + 1,
              0
            );
            this.loanApplication.repaymentDate =
              lastDayOfMonth.getFullYear() +
              "-" +
              ("0" + (lastDayOfMonth.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + lastDayOfMonth.getDate()).slice(-2);
            this.defaultRepaymentDate = this.loanApplication.repaymentDate;
          } else if (currentDate.getDate() > 8) {
            let lastDayOfNextMonth = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() + 2,
              0
            );
            this.loanApplication.repaymentDate =
              lastDayOfNextMonth.getFullYear() +
              "-" +
              ("0" + (lastDayOfNextMonth.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + lastDayOfNextMonth.getDate()).slice(-2);
            this.defaultRepaymentDate = this.loanApplication.repaymentDate;
          }
        } else if (this.$route.params.salaryFrequency === "Weekly") {
          let currentDate = new Date();
          const upcomingFriday = new Date(
            currentDate.setDate(
              currentDate.getDate() + ((7 - currentDate.getDay() + 5) % 7 || 7)
            )
          );
          this.loanApplication.repaymentDate =
            upcomingFriday.getFullYear() +
            "-" +
            ("0" + (upcomingFriday.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + upcomingFriday.getDate()).slice(-2);
          this.defaultRepaymentDate = this.loanApplication.repaymentDate;
        } else if (this.$route.params.salaryFrequency === "Fortnightly") {
          let currentDate = new Date();
          const upcomingFriday = new Date(
            currentDate.setDate(
              currentDate.getDate() + ((7 - currentDate.getDay() + 5) % 7 || 7)
            )
          );
          this.loanApplication.repaymentDate =
            upcomingFriday.getFullYear() +
            "-" +
            ("0" + (upcomingFriday.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + upcomingFriday.getDate()).slice(-2);
          this.defaultRepaymentDate = this.loanApplication.repaymentDate;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async whatAudioFile(audioFileName) {
      try {
        if (audioFileName === "English") {
          this.audioLoaded = false;
          this.currentAudioFileName = "English";
          this.currentAudioFile = await Storage.get(
            "audioFiles/Bradbury Agreement English.mp3",
            {
              level: "public",
            }
          );
          this.audioLoaded = true;
        } else if (audioFileName === "Afrikaans") {
          this.audioLoaded = false;
          this.currentAudioFileName = "Afrikaans";
          this.currentAudioFile = await Storage.get(
            "audioFiles/Bradbury Agreement Afrikaans.mp3",
            {
              level: "public",
            }
          );
          this.audioLoaded = true;
        } else if (audioFileName === "IsiZulu") {
          this.audioLoaded = false;
          this.currentAudioFileName = "IsiZulu";
          this.currentAudioFile = await Storage.get(
            "audioFiles/Bradbury Agreement IsiZulu.mp3",
            {
              level: "public",
            }
          );
          this.audioLoaded = true;
        } else {
          console.log("No audio found");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async submit() {
      try {
        this.loading = true;

        // this.modelEmployee = await DataStore.query(Employee, (e) =>
        //   e.idNumber('eq', this.employee.idNumber)
        // );

        // if (this.loanApplication.loanPurpose !== 'OTHER') {

        //use Appsync API to query Employee by idNumber
        const employeeQuery = `
          query ListEmployees($filter: ModelEmployeeFilterInput) {
            listEmployees(filter: $filter) {
              items {
                id
                title
                name
                surname
                idNumber
                email
                address
                cell
                companyID
                status
              }
            }
          }
        `;
        const employeeResponse = await API.graphql({
          query: employeeQuery,
          variables: {
            filter: { idNumber: { eq: this.employee.idNumber } },
          },
        });
        console.log("Employee Query Response:", employeeResponse);
        const employees = employeeResponse.data.listEmployees?.items || [];
        this.modelEmployee = employees[0] ? employees[0] : {};

        console.log("Model Employee:", this.modelEmployee);

        if (this.loanApplication.loanPurpose !== "OTHER") {
          this.loanApplication.loanPurposeOther = null;
        }

        //remove undefined fields from employee object
        Object.keys(this.employee).forEach(
          (key) => this.employee[key] === null && delete this.employee[key]
        );

        if (
          this.modelEmployee.id != null &&
          this.modelEmployee.id !== undefined
        ) {
          // this.modelEmployee = this.modelEmployee[0];
          // await DataStore.save(
          //   Employee.copyOf(this.modelEmployee, (updateEmployee) => {
          //     (updateEmployee.title = this.employee.title),
          //       (updateEmployee.name = this.employee.name),
          //       (updateEmployee.surname = this.employee.surname),
          //       (updateEmployee.idNumber = this.employee.idNumber),
          //       (updateEmployee.email = this.employee.email),
          //       (updateEmployee.address = this.employee.address),
          //       (updateEmployee.cell = this.employee.cell),
          //       (updateEmployee.companyID = this.employee.companyID),
          //       (updateEmployee.status = this.employee.status),
          //       (updateEmployee.LoanApplications = this.loanApplication);
          //   })
          // );

          //Use Appsync API to update Employee
          const updateEmployeeMutation = `
            mutation UpdateEmployee($input: UpdateEmployeeInput!) {
              updateEmployee(input: $input) {
                id
                title
                name
                surname
                idNumber
                email
                address
                cell
                companyID
                status
              }
            }
          `;

          const updatedEmployeeResponse = await API.graphql({
            query: updateEmployeeMutation,
            variables: {
              input: {
                id: this.modelEmployee.id,
                ...this.employee,
              },
            },
          });
          console.log("Updated Employee Response:", updatedEmployeeResponse);
          this.modelEmployee = updatedEmployeeResponse.data.updateEmployee;
        } else {
          // this.modelEmployee = await DataStore.save(
          //   new Employee({
          //     title: this.employee.title,
          //     name: this.employee.name,
          //     surname: this.employee.surname,
          //     idNumber: this.employee.idNumber,
          //     email: this.employee.email,
          //     address: this.employee.address,
          //     cell: this.employee.cell,
          //     companyID: this.employee.companyID,
          //     status: this.employee.status,
          //     LoanApplications: this.loanApplication,
          //   })
          // );
          //Use Appsync API to create new Employee
          const createEmployeeMutation = `
            mutation CreateEmployee($input: CreateEmployeeInput!) {
              createEmployee(input: $input) {
                id
                title
                name
                surname
                idNumber
                email
                address
                cell
                companyID
                status
        }
            }
          `;
          const createdEmployeeResponse = await API.graphql({
            query: createEmployeeMutation,
            variables: {
              input: {
                ...this.employee,
                // title: this.employee.title,
                // name: this.employee.name,
                // surname: this.employee.surname,
                // idNumber: this.employee.idNumber,
                // email: this.employee.email,
                // address: this.employee.address,
                // cell: this.employee.cell,
                // companyID: this.employee.companyID,
                // status: this.employee.status,
              },
            },
          });
          console.log("Created Employee Response:", createdEmployeeResponse);
          this.modelEmployee = createdEmployeeResponse.data.createEmployee;
        }

        const newLoanApplication = await DataStore.save(
          new LoanApplication({
            employeeID: this.modelEmployee.id,
            spouseTitle: this.loanApplication.spouseTitle,
            spouseName: this.loanApplication.spouseName,
            spouseSurname: this.loanApplication.spouseSurname,
            spouseIdNumber: this.loanApplication.spouseIdNumber,
            spouseEmail: this.loanApplication.spouseEmail,
            spouseAddress: this.loanApplication.spouseAddress,
            spouseCell: this.loanApplication.spouseCell,
            bankName: this.loanApplication.bankName,
            branchName: this.loanApplication.branchName,
            branchNumber: this.loanApplication.branchNumber,
            accountName: this.loanApplication.accountName,
            accountNumber: this.loanApplication.accountNumber,
            grossSalary: parseFloat(this.loanApplication.grossSalary),
            nettSalary: parseFloat(this.loanApplication.nettSalary),
            expenses: this.loanApplication.expenses,

            totalLeft: parseFloat(this.totalLeft),
            underAdministration: this.loanApplication.underAdministration,
            underDeptReview: this.loanApplication.underDeptReview,
            isThisEmergencyLoan: this.loanApplication.isThisEmergencyLoan,
            loanPurpose: this.loanApplication.loanPurpose,
            loanPurposeOther: this.loanApplication.loanPurposeOther,
            employeeClockNumber: this.loanApplication.employeeClockNumber,
            consent: this.loanApplication.consent,
            salaryFrequency: this.$route.params.salaryFrequency,
            status: this.loanApplication.status,
            fullName: this.loanApplication.fullName,
            repaymentDate: this.loanApplication.repaymentDate,
            employee: {
              id: this.modelEmployee.id,
              title: this.employee.title,
              name: this.employee.name,
              surname: this.employee.surname,
              idNumber: this.employee.idNumber,
              email: this.employee.email,
              address: this.employee.address,
              cell: this.employee.cell,
            },
            company: {
              id: this.modelCompany.id,
              companyEmail: this.modelCompany.companyEmail,
              loanApplicationEmails: this.modelCompany.loanApplicationEmails,
              name: this.modelCompany.name,
              pastelCode: this.modelCompany.pastelCode,
              region: this.companyMetaData.region,
              branch: this.companyMetaData.branch,
            },
            loanType: {
              id: this.loanApplication.loanType.id,
              periodNumber: this.loanApplication.loanType.periodNumber,
              period: this.loanApplication.loanType.period,
              code: this.loanApplication.loanType.code,
              randValue: this.loanApplication.loanType.randValue,
              adminFee: this.loanApplication.loanType.adminFee,
              creditType: this.loanApplication.loanType.creditType,
              creditLifeFee: this.loanApplication.loanType.creditLifeFee,
              debitOrder: this.loanApplication.loanType.debitOrder,
              serviceCharge: this.loanApplication.loanType.serviceCharge,
              totalPayment: this.loanApplication.loanType.totalPayment,
              interest: this.loanApplication.loanType.interest,
              payment: this.loanApplication.loanType.payment,
              totalInterest: this.loanApplication.loanType.totalInterest,
            },
          })
        );

        let arrPayslipKeys = [];
        for (let a in this.loanApplication.uploadPayslip) {
          const uploadedPayslip = await Storage.put(
            newLoanApplication.id +
              "/" +
              "payslips" +
              "/" +
              this.loanApplication.uploadPayslip[a].name,
            this.loanApplication.uploadPayslip[a]
          );
          arrPayslipKeys.push(uploadedPayslip.key);
        }

        const uploadedId = await Storage.put(
          newLoanApplication.id +
            "/" +
            "identification" +
            "/" +
            this.loanApplication.uploadId.name,
          this.loanApplication.uploadId
        );

        const uploadedSignatureImg = await Storage.put(
          newLoanApplication.id +
            "/" +
            "signature" +
            "/" +
            this.loanApplication.signatureImage.name,
          this.loanApplication.signatureImage
        );

        const uploadedProofOfBankImg = await Storage.put(
          newLoanApplication.id +
            "/" +
            "proofOfBank" +
            "/" +
            this.loanApplication.proofOfBank.name,
          this.loanApplication.proofOfBank
        );

        await DataStore.save(
          LoanApplication.copyOf(newLoanApplication, (updateApplication) => {
            updateApplication.identification = uploadedId.key;
            updateApplication.payslips = arrPayslipKeys;
            updateApplication.signatureImage = uploadedSignatureImg.key;
            updateApplication.proofOfBank = uploadedProofOfBankImg.key;
          })
        );

        const baseUrl = window.location.origin;
        // const linkId = baseUrl + "/download/" + uploadedId.key;
        // // await Storage.get(uploadedId.key, {
        // //   level: "public",
        // //   expires: 604800,
        // // });
        // const linkProofOfBank =
        //   baseUrl + "/download/" + uploadedProofOfBankImg.key;
        // // await Storage.get(uploadedProofOfBankImg.key, {
        // //   level: "public",
        // //   expires: 604800,
        // // });
        // const linkSignatureImg =
        //   baseUrl + "/download/" + uploadedSignatureImg.key;
        // // await Storage.get(uploadedSignatureImg.key, {
        // //   level: "public",
        // //   expires: 604800,
        // // });
        // let payslips = "";
        // let countPayslips = 0;
        // for (let i in arrPayslipKeys) {
        //   countPayslips = countPayslips + 1;
        //   const linkPayslip = baseUrl + "/download/" + arrPayslipKeys[i];
        //   // await Storage.get(arrPayslipKeys[i], {
        //   //   level: "public",
        //   //   expires: 604800,
        //   // });
        //   payslips =
        //     payslips +
        //     "<p>Payslip " +
        //     countPayslips +
        //     ": <a href='" +
        //     linkPayslip +
        //     "'>Download</a></p>";
        // }
        let emails = [];
        if (this.$route.params.salaryFrequency === "Monthly") {
          emails = this.modelCompany.loanApplicationEmails.Months?.split(",");
        } else if (this.$route.params.salaryFrequency === "Weekly") {
          emails = this.modelCompany.loanApplicationEmails.Weeks?.split(",");
        } else if (this.$route.params.salaryFrequency === "Fortnightly") {
          emails =
            this.modelCompany.loanApplicationEmails.Fortnights?.split(",");
        }
        if (emails.length > 0 && emails[0] !== "") {
          // var ses = new AWS.SES();

          var params = {
            Destinations: [
              /* required */
              {
                Destination: {
                  /* required */
                  // BccAddresses: [
                  //   'STRING_VALUE',
                  //   /* more items */
                  // ],
                  CcAddresses: [
                    /* more items */
                  ],
                  ToAddresses: emails,
                },
                // ReplacementTags: [
                //   {
                //     Name: 'STRING_VALUE', /* required */
                //     Value: 'STRING_VALUE' /* required */
                //   },
                //   /* more items */
                // ],
                ReplacementTemplateData:
                  '{"companyName":"' +
                  this.modelCompany.name +
                  '", ' +
                  '"employeeName":"' +
                  this.employee.name +
                  " " +
                  this.employee.surname +
                  '", ' +
                  '"applicationLink":"' +
                  baseUrl +
                  "/view/" +
                  newLoanApplication.id +
                  '", ' +
                  '"attachmentsLink":"' +
                  baseUrl +
                  "/downloads/" +
                  newLoanApplication.id +
                  '"}',
              },
              /* more items */
            ],
            Source: "lee@bradburyfin.co.za" /* required */,
            Template: "LoanApplicationTemplate" /* required */, //"NewApplicationToHRTemplate","NewLoanApplicationTemplate"
            // ConfigurationSetName: 'STRING_VALUE',
            // DefaultTags: [
            //   {
            //     Name: 'STRING_VALUE', /* required */
            //     Value: 'STRING_VALUE' /* required */
            //   },
            //   /* more items */
            // ],
            DefaultTemplateData:
              '{ "companyName":" Error", "employeeName":" Error", "applicationLink":"New Bradbury Assist Application" }',
            // ReplyToAddresses: [
            //   'STRING_VALUE',
            //   /* more items */
            // ],
            // ReturnPath: 'STRING_VALUE',
            // ReturnPathArn: 'STRING_VALUE',
            // SourceArn: 'STRING_VALUE',
            // TemplateArn: 'STRING_VALUE'
          };

          await API.post(
            "bradburyassistlambdafunctionapi",
            "/item/applicationFormSendEmails",
            {
              body: params,
            }
          )
            // .then((sendEmailsResponse) => {
            //   console.log('sendEmailsResponse: ', sendEmailsResponse)
            // })
            .catch((error) => {
              // Log any errors
              console.log("error:", error);
            });
        }

        this.submitError = false;
        this.submitted = true;
      } catch (err) {
        this.submitted = false;
        this.submitError = true;
        console.log(err);
      } finally {
        // router.push({
        //   name: "Landing",
        // });
        this.loading = false;
      }
    },
    yesNo(label, bool) {
      this.acceptAll =
        this.loanApplication.underAdministration &&
        this.loanApplication.underDeptReview &&
        this.loanApplication.isThisEmergencyLoan;
      if (bool === true) {
        return label + " " + "YES";
      } else {
        return label + " " + "NO";
      }
    },
    acceptAllClick() {
      this.loanApplication.underAdministration = this.acceptAll;
      this.loanApplication.underDeptReview = this.acceptAll;
      this.loanApplication.isThisEmergencyLoan = this.acceptAll;
    },
  },
  computed: {
    proofOfBankInputStyle() {
      let size = this.proofOfBankImgSize;
      if (size === "100vw") {
        return "width: 100%";
      } else {
        size = parseInt(size.slice(0, -2)) * 2;

        return "width: " + size + "px";
      }
    },
    signatureInputStyle() {
      let size = this.signatureImgSize;
      return "width: " + size;
    },
    submittedDialogSize() {
      var size = String;
      if (this.$vuetify.breakpoint.xs) {
        size = "100vw";
      } else if (this.$vuetify.breakpoint.sm) {
        size = "450px";
      } else if (this.$vuetify.breakpoint.md) {
        size = "500px";
      } else if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
        size = "600px";
      }
      return size;
    },
    proofOfBankImgSize() {
      var size = String;
      if (this.$vuetify.breakpoint.xs) {
        size = "100vw";
      } else if (this.$vuetify.breakpoint.sm) {
        size = "300px";
      } else if (this.$vuetify.breakpoint.md) {
        size = "400px";
      } else if (this.$vuetify.breakpoint.lg) {
        size = "500px";
      } else if (this.$vuetify.breakpoint.xl) {
        size = "600px";
      }
      return size;
    },
    signatureImgSize() {
      var size = String;
      if (this.$vuetify.breakpoint.xs) {
        size = "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        size = "548px";
      } else if (this.$vuetify.breakpoint.md) {
        size = "600px";
      } else if (this.$vuetify.breakpoint.lg) {
        size = "700px";
      } else if (this.$vuetify.breakpoint.xl) {
        size = "800px";
      }
      return size;
    },
    otherLoanPurposeRules() {
      if (this.loanApplication.loanPurpose) {
        return false;
      } else {
        return true;
      }
    },
    isValid() {
      if (this.valid && this.loanApplication.loanType) {
        return true;
      } else {
        return false;
      }
    },
    totalLeft() {
      let totalExpenseAmount = _.sumBy(this.loanApplication.expenses, "amount");

      return this.loanApplication.nettSalary - totalExpenseAmount;
    },
  },
};
</script>
<style>
@font-face {
  font-family: "FullNameFont";
  src: local("FullNameFont"), url(@/fonts/EduSABeginner-Regular.ttf);
}

#FullNameTextField {
  font-family: "FullNameFont";
  font-weight: 600;
  font-size: 21px;
  padding: 0px;
}
</style>
